<template>
  <div class="d-inline">
    <template v-for="(value, name) in allFilters">
      <template v-if="value.constructor.name !== 'Object'">
        <v-chip v-for="filter in value" :key="filter" class="mr-1 my-1" close @click:close="filterToggle(name, filter)">
          <b>{{ getLabel(name) + ":" }}&nbsp;</b>
          <b class="font-weight-regular">{{ filter }}</b>
        </v-chip>
      </template>
      <v-chip v-else :key="name" class="mr-1 my-1" close @click:close="rangeChange(name)">
        <b class="font-weight-regular">{{ value.min }}</b>&nbsp;
        <b>{{ " ≥ " + getLabel(name) + " ≥ " }}</b>&nbsp;
        <b class="font-weight-regular">{{ value.max }}</b>
      </v-chip>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
  filterToggle: {
    type: Function,
    required: true
  },
  selectedFilters: {
    type: Object,
    required: true
  },
  selectedRanges: {
    type: Object,
    required: true
  },
  rangeChange: {
    type: Function,
    required: true
  },
  facets: {
    type: Array,
    default: () => []
  }
});

const allFilters = computed(() => ({ ...props.selectedFilters, ...props.selectedRanges }));

const getLabel = attribute => {
  // Gets the right label for current refinement

  // If content type
  switch (attribute) {
    case 'wtype':
      return 'Content-Type';
    case 'wpath.lvl0':
      return 'Folders';
    default: break;
  }

  const facet = props.facets.find(f => f.attribute === attribute);
  return facet ? facet.label : attribute;
};

</script>
